import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
function updateQueryStringParams(uri, key, value) {
  var re = new RegExp("([?&])".concat(key, "=.*?(&|$)"), 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, "$1".concat(key, "=").concat(value, "$2"));
  }
  return "".concat(uri + separator + key, "=").concat(value);
}
export default updateQueryStringParams;